import ReLogin from './ReLogin';
import './ReLogin.css';

export default ReLogin;


// WEBPACK FOOTER //
// ./src/components/ReLogin/index.ts